import{initSentry}from"app/client/error.web";initSentry();